import type { ComponentType } from 'react';
import type { QuickLink } from '../../../helpers/flora-quick-links/flora-quick-links.type';
import type { ArtifactType } from '../../flora/flora.type';

interface ArtifactComponentProps {
  data: Record<string, unknown>;
  config?: Record<string, unknown>;
  quickLinks?: QuickLink[];
  onQuickLinksChange?: (links: QuickLink[]) => void;

  initialState?: Record<string, unknown>;
}

type ArtifactEntry = {
  component: ComponentType<ArtifactComponentProps>;
  label: string;
};

const registry = new Map<ArtifactType, ArtifactEntry>();

/**
 * Registers an artifact renderer by type. Called once per artifact at module
 * load time via `register-artifacts.ts`.
 *
 * @param {ArtifactType} type - The artifact discriminator from the BE.
 * @param {ArtifactEntry} entry - Component + label to render.
 * @returns {void}
 */
function registerArtifact(type: ArtifactType, entry: ArtifactEntry): void {
  registry.set(type, entry);
}

/**
 * Looks up a registered artifact entry by type.
 *
 * @param {ArtifactType} type - The artifact discriminator from the BE.
 * @returns {ArtifactEntry | undefined} The registered entry, or undefined if
 *   no artifact has been registered for this type.
 */
function getArtifactEntry(type: ArtifactType): ArtifactEntry | undefined {
  return registry.get(type);
}

export { getArtifactEntry, registerArtifact };
export type { ArtifactComponentProps };
